<template>
  <div class="order__list">
    <!-- 订单列表 -->
    <div class="order__list_top">
      <div class="order__list__title">
        <span>
          下单人：
          <span class="order-no">
            {{ orderInfo.submitSaleManName ? orderInfo.submitSaleManName : orderInfo.buyerName }}
          </span>
        </span>
        <span>
          下单时间：
          <span class="order-no">
            {{ orderInfo.submitOrderTime }}
          </span>
        </span>
        <span>
          订单号：
          <span :data-clipboard-text="shareText" @click="copyOrderNo" class="copy pointer order-no">
            {{ orderInfo.orderSn }}
          </span>
        </span>
        <span class="order-on-behalf-of-customer-tag" v-if="orderInfo.isSaleManSubmit === 'yes'">销售代下单</span>
      </div>
    </div>
    <div class="order__list_bottom">
      <div class="bottom-row store">
        <div class="store__title">
          <img
            v-if="orderInfo.shopIcon && orderInfo.shopIcon != ''"
            :src="orderInfo.shopIcon"
            alt=""
            class="shop-logo"
          />
          <img v-else :src="require('@/assets/img/shop-logo.png')" class="shop-logo" />
          <span @click="linkToStore(orderInfo)" class="pointer">
            {{ orderInfo.shopName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ orderInfo.merchantEntityName }}
          </span>
          <span @click.stop="onContactCustomerService" class="pointer store__title__contact">
            <img :src="require('@/assets/img/service-icon.png')" alt="" />
            联系商家
          </span>
        </div>
        <div style="margin: 16px 20px">
          <div v-for="(good, index) in orderInfo.orderItems || []" class="store__goods">
            <img
              @click="handlerItemDetailClick(good)"
              class="img pointer"
              v-if="good.itemThumbnail"
              :src="good.itemThumbnail + '?x-oss-process=image/resize,w_240/quality,q_90'"
            />
            <img
              @click="handlerItemDetailClick(good)"
              class="img pointer"
              v-else
              :src="require('@/assets/img/goods-empty.png')"
            />
            <div class="item">
              <div @click="handlerItemDetailClick(good)" class="item__detail pointer">{{ good.itemName }}</div>
              <div class="item__specs">{{ good.itemContent.spec }}</div>
              <div class="item__number">
                <span class="item__number__tag">x {{ good.number }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-row item_total">¥{{ price(orderInfo.totalItemAmount) }}</div>
      <div class="bottom-row item_disamount_total">¥{{ price(orderInfo.discountAmount) }}</div>
      <div class="bottom-row total_amount">
        <div class="price">¥{{ price(orderInfo.orderAmount) }}</div>
        <div class="express">（含运费：¥{{ price(orderInfo.shippingAmount) }}）</div>
        <div class="pay">
          {{ orderInfo.payId === 0 ? '线上支付' : '对公转账' }}
        </div>
      </div>
      <div class="bottom-row status">
        <div class="text delivery">
          {{ getPayText(orderInfo.status) }}
        </div>
        <div @click="goDetail(orderInfo.orderSn)" class="text order__detail pointer">订单详情</div>
      </div>
      <div class="bottom-row option">
        <div
          v-if="orderInfo.status === 1 && orderInfo.auditStatus !== 1"
          class="opera__btn"
          @click.stop="onPay(orderInfo)"
        >
          {{ orderInfo.payId === 0 ? '去支付' : '对公转账' }}
        </div>
        <div
          v-if="
            orderInfo.status === 1 && orderInfo.auditStatus !== 1 && (orderInfo.payId === 0 || orderInfo.payId === 103)
          "
          class="opera__btn"
          @click.stop="payOnBehalf(orderInfo)"
        >
          他人代付
        </div>
        <div class="opera__btn" v-if="orderInfo.status === 3" @click.stop="confirmOrder(orderInfo.orderSn)">
          确认收货
        </div>
        <div
          class="opera__span"
          v-if="orderInfo.status === 3 || orderInfo.status === 4"
          @click.stop="goDetail(orderInfo.orderSn)"
        >
          查看配送
        </div>
        <div class="opera__span" @click.stop="showCei(orderInfo.orderSn)">查看随货资质</div>
        <div
          class="opera__span"
          v-if="
            (orderInfo.status === 2 || orderInfo.status === 3 || orderInfo.status === 4) &&
            (orderInfo.orderInvoices || []).length
          "
          @click.stop="showInvoice(orderInfo.orderSn)"
        >
          查看发票
        </div>
        <div
          class="opera__span"
          v-if="orderInfo.status === 1 && orderInfo.auditStatus !== 1"
          @click.stop="onCancelOrder(orderInfo.orderSn)"
        >
          取消订单
        </div>
        <div
          class="opera__span"
          v-if="orderInfo.status === 4 || orderInfo.status === 5 || orderInfo.status === 7"
          @click.stop="bathAdd(orderInfo.orderSn)"
        >
          再次购买
        </div>
        <!--        <div class="opera__span" v-if="orderInfo.isRefunding" @click.stop="confirmRefund(orderInfo.orderSn)">-->
        <!--          确认收到退款-->
        <!--        </div>-->
        <div class="opera__span" @click.stop="showContract(orderInfo.orderSn)">查看合同</div>
        <!-- 状态：1-待支付、2-待配送、3-配送中、4-配送完成、5-已关闭、6-待开户、8-待开单 -->
        <div
          class="opera__span"
          v-if="[2, 3, 4].includes(orderInfo.status)"
          @click.stop="showDownloadDialog(orderInfo.orderSn, 'DRUG_INSPECTION_REPORT')"
        >
          下载药品检查单
        </div>
        <div
          class="opera__span"
          v-if="[1, 2, 3, 4, 5, 6, 8].includes(orderInfo.status)"
          @click.stop="showDownloadDialog(orderInfo.orderSn, 'INITIAL_QUALIFICATION')"
        >
          下载商品首营
        </div>
      </div>
    </div>
    <!-- 随货资质弹窗 -->
    <CertificationDetail :info="orderDetail" ref="certificationDialogRef" />

    <el-dialog :title="orderDialogData.title" :visible.sync="orderDialogData.visible" width="30%" alignFooter="right">
      <div class="items">
        <div class="item" v-for="item in orderDialogData.data">
          <div class="goods-name" v-if="item.generateStatus !== 'ERROR'">{{ item.itemTitle }}</div>
          <div class="goods-name-error" v-if="item.generateStatus === 'ERROR'">{{ item.itemTitle }}</div>
          <div class="generate-status" v-if="item.generateStatus === 'ERROR'">未开具</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderDialogData.visible = false">取 消</el-button>
        <el-button type="primary" @click="downloadAll" :loading="downloading">下载全部</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="orderDialogEmpty.title" :visible.sync="orderDialogEmpty.visible" width="30%" alignFooter="right">
      <span>{{ orderDialogEmpty.description }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="orderDialogEmpty.visible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { priceFenToYuan } from '@/helpers/utils';
import { mapActions } from 'vuex';
import CertificationDetail from '../../OrderDetail/components/CertificationDetail.vue';
import * as api from '@/services';
import { downloadFile } from '@/utils';
const { ORDER_STATUS, orderQueryStatus } = require('../../constants/order');

const QUA_TYPES = {
  DRUG_INSPECTION_REPORT: '药品检查单',
  INITIAL_QUALIFICATION: '商品首营资料'
};
export default {
  props: {
    orderInfo: {
      type: Object
    }
  },
  components: {
    CertificationDetail
  },
  data() {
    return {
      orderDetail: {},
      shareText: '',
      ORDER_STATUS,
      downloading: false,
      orderDialogData: {
        title: '', // 查看商品首营、查看药品检查单
        visible: false,
        data: [], // 列表数据
        params: {}
      },
      orderDialogEmpty: {
        title: '提示',
        description: '该订单中商品首营资料为空，请联系工作人员添加',
        visible: false
      }
    };
  },
  methods: {
    ...mapActions('cart', ['setSuccessCartIds', 'setCartFailList']),
    linkToStore(item) {
      this.$router.push({ path: `/store/${item.shopId}/homePage` });
    },
    showContract(sn) {
      this.$emit('showContract', sn);
    },

    // 他人代付
    payOnBehalf(orderInfo) {
      this.$router.push(`/pay_payOnBehalf/${orderInfo.orderSn}`);
    },

    // 商品首营、药检单弹窗
    async showDownloadDialog(sn, orderQuaType) {
      const res = await api.order.getOrderQua({
        orderSn: sn, // 订单号
        orderQuaType: orderQuaType // 订单资质类型 DRUG_INSPECTION_REPORT 药检单 INITIAL_QUALIFICATION 首营资质
      });
      // NONE-未生成 PART-部分生成 ALL-全部生成
      if (res.orderGenerateStatus === 'NONE') {
        if (orderQuaType === 'DRUG_INSPECTION_REPORT') {
          this.orderDialogEmpty.description = '该订单中药品检查单为空，请联系工作人员添加';
        } else {
          this.orderDialogEmpty.description = '该订单中商品首营资料为空，请联系工作人员添加';
        }
        this.orderDialogEmpty.visible = true;
        return;
      }
      this.orderDialogData.params = {
        orderSn: sn, // 订单号
        orderQuaType: orderQuaType // 订单资质类型 DRUG_INSPECTION_REPORT 药检单 INITIAL_QUALIFICATION 首营资质
      };
      this.orderDialogData.data = res.itemInfo;
      if (orderQuaType === 'DRUG_INSPECTION_REPORT') {
        // 药检单
        Telescope.trackEvent({
          trackId: 'zyb2bpc-event-ddy-ddlbyxzydjcd'
        });
        this.orderDialogData.title = '下载药品检查单';
      } else if (orderQuaType === 'INITIAL_QUALIFICATION') {
        // 首营
        Telescope.trackEvent({
          trackId: 'zyb2bpc-event-ddy-ddlbyxzspsyzl'
        });
        this.orderDialogData.title = '下载商品首营';
      }
      this.orderDialogData.visible = true;
    },
    async downloadAll() {
      this.downloading = true;
      try {
        const res = await api.order.downloadOrderQua(this.orderDialogData.params);
        let fileName = '';
        if (this.orderDialogData.params.orderQuaType === 'DRUG_INSPECTION_REPORT') {
          // 药检单
          fileName = `药品检查单（${this.orderDialogData.params.orderSn}）.zip`;
        } else if (this.orderDialogData.params.orderQuaType === 'INITIAL_QUALIFICATION') {
          // 商品首营
          fileName = `商品首营资料（${this.orderDialogData.params.orderSn}）.zip`;
        }
        await downloadFile(res.fileUrl, fileName);
        this.downloading = false;
      } catch (e) {
        console.error(e);
        this.downloading = false;
      }
    },

    copyOrderNo() {
      if (this.copyBtn) {
        this.copyBtn.destroy();
      }
      this.copyBtn = new this.clipboard('.copy');
      this.shareText = this.orderInfo.orderSn;
      // eslint-disable-next-line new-cap
      this.copyBtn.on('success', () => {});
      this.copyBtn.on('error', (err) => {});
      this.$message.success('复制成功');
    },
    handlerItemDetailClick(goods) {
      this.$router.push(`/goodsDetails/${goods.itemCode}`);
    },
    async bathAdd(orderSn) {
      try {
        const res = await api.cart.batchAddCart({ orderSn: orderSn }, { handleError: true });
        this.setSuccessCartIds(res.addSuccessCartIds);
        this.setCartFailList(res.addCartFailList);
        if (res.addSuccessCartIds && res.addSuccessCartIds.length) {
          this.$router.push('/cart');
        } else {
          this.$message.error('加购失败，请看看其他商品吧');
        }
      } catch (error) {
        this.$message.error('加购失败，请看看其他商品吧');
      }
    },
    // 联系客服
    onContactCustomerService() {
      this.$emit('contactCustomerService');
    },
    onPay(orderInfo) {
      this.$emit('pay', orderInfo);
    },
    onCancelOrder(orderSn) {
      this.$emit('cancelorder', orderSn);
    },
    confirmRefund(orderInfo) {
      this.$emit('confirmRefund', orderInfo);
    },
    async showCei(orderSn) {
      const res = await api.order.getOrderDetail({ orderSn: orderSn });
      this.orderDetail = res;
      this.$refs.certificationDialogRef.dialogVisible = true;
    },
    async showInvoice(orderSn) {
      const res = await api.order.getOrderDetail({ orderSn: orderSn });
      this.$previewImgList({
        urls: res.orderInvoices
      });
    },
    goDetail(orderSn) {
      window.open(encodeURI(location.origin + location.pathname + `#/orderDetail?orderSn=${orderSn}`));
    },
    getPayText(status) {
      const option = orderQueryStatus.filter((option) => {
        return option.value === status;
      });
      return option[0].label;
    },
    confirmOrder(orderSn) {
      this.$emit('confirmOrder', orderSn);
    },
    price(val) {
      return priceFenToYuan(val);
    },
    goodAmount(orderItems) {
      const amount = orderItems.reduce((total, item) => {
        return total + item.number;
      }, 0);
      return amount;
    }
  }
};
</script>

<style lang="scss" scoped>
.order__list {
  display: flex;
  flex-direction: column;
  .order__list_top {
    border-left: 1px solid #dfdfdf;
    border-right: 1px solid #dfdfdf;
    .order__list__title {
      height: 44px;
      padding: 0 16px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 44px;
      border-top: 1px solid #dfdfdf;
      border-bottom: 1px solid #dfdfdf;
      .order-no {
        color: #333333;
      }
      span + span {
        margin-left: 16px;
      }
    }
  }
  .order__list_bottom {
    display: flex;
    flex-direction: row;
    .bottom-row {
      border-right: 1px solid #dfdfdf;
      &.store {
        width: 488px;
        border-left: 1px solid #dfdfdf;
      }
      &.item_total {
        width: 127px;
        text-align: center;
        padding-top: 16px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 12px;
      }
      &.item_disamount_total {
        width: 127px;
        text-align: center;
        padding-top: 16px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 12px;
      }
      &.total_amount {
        width: 188px;
        text-align: center;
        padding-top: 16px;
      }
      &.status {
        width: 150px;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        line-height: 1;
        text-align: center;
        padding-top: 16px;
        .text {
          margin-bottom: 12px;
        }
      }
      .order__detail {
        color: #1e8dff;
      }
      &.option {
        width: 151px;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        line-height: 1;
        text-align: center;
        padding-top: 16px;
      }
    }
    .price {
      font-size: 12px;
      font-weight: 500;
      color: #333333;
      line-height: 1;
      margin-bottom: 8px;
    }
    .express {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 1;
      margin-bottom: 8px;
    }
    .pay {
      font-size: 12px;
      font-weight: 400;
      color: #888888;
      line-height: 1;
    }
    .opera__btn {
      width: 64px;
      cursor: pointer;
      padding: 6px 8px;
      background: #1e8dff;
      color: #ffffff;
      margin: 0 auto;
      margin-bottom: 12px;
    }
    .opera__span {
      cursor: pointer;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 12px;
      margin-bottom: 12px;
    }
  }

  .store {
    &__title {
      height: 44px;
      padding: 0 20px;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 44px;
      border-bottom: 1px solid #dfdfdf;

      display: flex;
      align-items: center;
      .shop-logo {
        margin-right: 8px;
        width: 30px;
        height: 30px;
      }
      &__contact {
        margin-left: 12px;
        font-size: 12px;
        font-weight: 400;
        color: #1e8dff;
        line-height: 1;
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }
      }
    }
    &__goods {
      display: flex;
      margin-bottom: 16px;
      .img {
        width: 80px;
        height: 80px;
        background: #ebebeb;
      }
      .item {
        position: relative;
        margin-left: 8px;
        &__detail {
          margin-bottom: 8px;
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          line-height: 1;
        }
        &__specs,
        &__number {
          font-size: 12px;
          font-weight: 400;
          color: #888888;
          line-height: 1;
        }
        &__number {
          position: absolute;
          bottom: 0;
          &__tag {
            color: #d96900;
          }
        }
      }
    }
  }

  .items {
    width: 100%;
    min-height: 110px;
    max-height: 280px;
    overflow-y: scroll;
  }
  .item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: row;
    font-size: 12px;
    line-height: 22px;
    margin-bottom: 16px;
  }
  .goods-name {
    max-width: 302px;
  }
  .goods-name-error {
    max-width: 302px;
    color: #a8a8a8;
  }
  .generate-status {
    color: #a8a8a8;
  }
  .order-on-behalf-of-customer-tag {
    width: 62px;
    height: 18px;
    line-height: 18px;
    border-radius: 1px;
    background: #e89b03;
    color: #ffffff;
    padding: 4px 6px;
  }
}
</style>
